import React, { useEffect } from 'react';
import Layout from '../../Layout';
import './Voucher.scss';
import { Breadcrumb, DatePicker, Table, TableColumnsType, Space, TableProps } from 'antd';
import ChartFunnel from '../../components/MarketingCampaigns/ChartFunnelVoucher';
import { CaretUpOutlined, DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { RangePicker } = DatePicker;

interface DataType {
  key: React.Key;
  hd: string;
  tct: string;
  count: number;
  dg: number;
  dn: number;
  dd: number;
  rate: string;
  date: string;
}

const columns: TableColumnsType<DataType> = [
  {
    title: 'Hành động',
    dataIndex: 'hd',
    align: 'center',
    render: () => (
      <Space size="middle">
        <Link to={'/analysis-report/voucher/1'}><span><EyeOutlined /></span></Link>
      </Space>
    ),
  },
  {
    title: 'Tên chương trình',
    dataIndex: 'tct',
  },
  {
    title: 'Số Voucher phát hành',
    dataIndex: 'count',
    align: 'center',
  },
  {
    title: 'Đã gửi',
    dataIndex: 'dg',
    align: 'center',
    sorter: {
      compare: (a, b) => a.dg - b.dg,
      multiple: 1,
    },
  },
  {
    title: 'Đã nhận',
    dataIndex: 'dn',
    align: 'center',
    sorter: {
      compare: (a, b) => a.dn - b.dn,
      multiple: 1,
    },
  },
  {
    title: 'Đã dùng',
    dataIndex: 'dd',
    align: 'center',
    sorter: {
      compare: (a, b) => a.dd - b.dd,
      multiple: 1,
    },
  },
  {
    title: 'Tỉ lệ dùng',
    dataIndex: 'rate',
    align: 'center',
  },
  {
    title: 'Thời gian gửi',
    dataIndex: 'date',
    align: 'center',
    sorter: {
      compare: (a, b) => a.dd - b.dd,
      multiple: 1,
    },
  }
];

const data: DataType[] = [
  {
    key: '1',
    hd: 'John Brown',
    tct: 'Giới thiệu xe BMW',
    count: 200,
    dg: 190,
    dn: 20,
    dd: 10,
    rate: '10%',
    date: '28/10/2023',
  },
  {
    key: '2',
    hd: 'John Brown',
    tct: 'Giới thiệu xe BMW',
    count: 200,
    dg: 190,
    dn: 20,
    dd: 10,
    rate: '10%',
    date: '28/10/2023',
  },
  {
    key: '3',
    hd: 'John Brown',
    tct: 'Đăng ký lái thử',
    count: 200,
    dg: 190,
    dn: 20,
    dd: 10,
    rate: '10%',
    date: '28/10/2023',
  },

];

const onChangeTB: TableProps<DataType>['onChange'] = (pagination, filters, sorter, extra) => {
  console.log('params', pagination, filters, sorter, extra);
};


const Voucher: React.FC = () => {
  useEffect(() => {
    document.title = 'THACO AUTO CRM';
  }, []);

  return (
    <div className="voucher-page">
      <Layout>
        <Breadcrumb
          items={[
            {
              title: 'THACO AUTO CRM',
            },
            {
              title: <a href="/">Báo cáo phân tích</a>,
            },
            {
              title: 'Voucher',
            },
          ]}
        />

        <div className='title-page'>
          Báo cáo chương trình Voucher
        </div>
        <div className="filter-block">
          <div className="left">
            <div className="title">Báo cáo tổng quan Voucher</div>
          </div>
          <div className="right">
            <div className="t-ctrl-date-picker-block t-ctrl-date-picker-bg mw-400">
              <RangePicker popupClassName="t-ctrl-date-picker" placeholder={["Từ ngày", "Đến ngày"]} />
            </div>
          </div>
        </div>

        <div className="marketing-campaigns-content voucher-content">
          <div className="overview">
            <div className="total">
              <div className="title-block">
                <div className="title">Tổng quan</div>
                <div className="icon-svg">
                  <svg width="1em" height="1em" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_9091_1009)">
                      <path d="M15.3714 6.11112C14.9698 5.1606 14.3877 4.29702 13.6571 3.56826C12.9284 2.83774 12.0648 2.25555 11.1143 1.85397C10.1268 1.43612 9.08036 1.2254 8 1.2254C6.91964 1.2254 5.87321 1.43612 4.88571 1.85397C3.93519 2.25555 3.07162 2.83774 2.34286 3.56826C1.61234 4.29702 1.03015 5.1606 0.628571 6.11112C0.210714 7.09862 0 8.14505 0 9.2254C0 11.595 1.04107 13.8272 2.85536 15.3522L2.88571 15.3772C2.98929 15.4629 3.11964 15.5111 3.25357 15.5111H12.7482C12.8821 15.5111 13.0125 15.4629 13.1161 15.3772L13.1464 15.3522C14.9589 13.8272 16 11.595 16 9.2254C16 8.14505 15.7875 7.09862 15.3714 6.11112ZM12.4536 14.154H3.54643C2.85642 13.5318 2.30494 12.7715 1.92778 11.9225C1.55062 11.0734 1.3562 10.1545 1.35714 9.2254C1.35714 7.4504 2.04821 5.78255 3.30357 4.52897C4.55893 3.27362 6.22679 2.58255 8 2.58255C9.775 2.58255 11.4429 3.27362 12.6964 4.52897C13.9518 5.78433 14.6429 7.45219 14.6429 9.2254C14.6429 11.1111 13.8482 12.895 12.4536 14.154ZM9.99107 6.75219C9.96422 6.7256 9.92796 6.71069 9.89018 6.71069C9.85239 6.71069 9.81614 6.7256 9.78929 6.75219L8.28036 8.26112C7.94643 8.17183 7.57679 8.25755 7.31429 8.52005C7.22131 8.61285 7.14755 8.72307 7.09722 8.84441C7.04689 8.96575 7.02099 9.09583 7.02099 9.22719C7.02099 9.35855 7.04689 9.48863 7.09722 9.60997C7.14755 9.73131 7.22131 9.84153 7.31429 9.93433C7.40709 10.0273 7.51731 10.1011 7.63865 10.1514C7.75999 10.2017 7.89007 10.2276 8.02143 10.2276C8.15279 10.2276 8.28287 10.2017 8.40421 10.1514C8.52555 10.1011 8.63577 10.0273 8.72857 9.93433C8.85294 9.81034 8.94237 9.65572 8.98784 9.48609C9.0333 9.31646 9.03319 9.13783 8.9875 8.96826L10.4964 7.45933C10.5518 7.40398 10.5518 7.3129 10.4964 7.25755L9.99107 6.75219ZM7.60714 4.93969H8.39286C8.47143 4.93969 8.53572 4.8754 8.53572 4.79683V3.36826C8.53572 3.28969 8.47143 3.2254 8.39286 3.2254H7.60714C7.52857 3.2254 7.46429 3.28969 7.46429 3.36826V4.79683C7.46429 4.8754 7.52857 4.93969 7.60714 4.93969ZM12.25 8.83255V9.61826C12.25 9.69683 12.3143 9.76112 12.3929 9.76112H13.8214C13.9 9.76112 13.9643 9.69683 13.9643 9.61826V8.83255C13.9643 8.75398 13.9 8.68969 13.8214 8.68969H12.3929C12.3143 8.68969 12.25 8.75398 12.25 8.83255ZM12.4768 5.31112L11.9214 4.75576C11.8946 4.72917 11.8583 4.71426 11.8205 4.71426C11.7828 4.71426 11.7465 4.72917 11.7196 4.75576L10.7089 5.76647C10.6823 5.79332 10.6674 5.82958 10.6674 5.86737C10.6674 5.90515 10.6823 5.94141 10.7089 5.96826L11.2643 6.52362C11.3196 6.57898 11.4107 6.57898 11.4661 6.52362L12.4768 5.5129C12.5321 5.45755 12.5321 5.36647 12.4768 5.31112ZM4.2875 4.75576C4.26065 4.72917 4.22439 4.71426 4.18661 4.71426C4.14882 4.71426 4.11256 4.72917 4.08571 4.75576L3.53036 5.31112C3.50377 5.33797 3.48886 5.37423 3.48886 5.41201C3.48886 5.4498 3.50377 5.48605 3.53036 5.5129L4.54107 6.52362C4.59643 6.57898 4.6875 6.57898 4.74286 6.52362L5.29821 5.96826C5.35357 5.9129 5.35357 5.82183 5.29821 5.76647L4.2875 4.75576ZM3.53571 8.68969H2.10714C2.02857 8.68969 1.96429 8.75398 1.96429 8.83255V9.61826C1.96429 9.69683 2.02857 9.76112 2.10714 9.76112H3.53571C3.61429 9.76112 3.67857 9.69683 3.67857 9.61826V8.83255C3.67857 8.75398 3.61429 8.68969 3.53571 8.68969Z" fill="white" />
                    </g>
                    <defs>
                      <clipPath id="clip0_9091_1009">
                        <rect width="16" height="16" fill="white" transform="translate(0 0.366089)" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
              <div className="voucher-list-item">
                <div className="one-item">
                  <div className="title">Số chương trình</div>
                  <div className="number">2</div>
                  <div className="rate-block">
                    <div className="text">Tăng 2%</div>
                    <div className="icon-svg"><CaretUpOutlined /></div>
                  </div>
                </div>
                <div className="one-item">
                  <div className="title">Số voucher phát hành</div>
                  <div className="number">30,000</div>
                  <div className="rate-block">
                    <div className="text">Tăng 12%</div>
                    <div className="icon-svg"><CaretUpOutlined /></div>
                  </div>
                </div>
                <div className="one-item">
                  <div className="title">Số voucher đã nhận</div>
                  <div className="number">1,000</div>
                  <div className="rate-block">
                    <div className="text">Tăng 2%</div>
                    <div className="icon-svg"><CaretUpOutlined /></div>
                  </div>
                </div>
                <div className="one-item">
                  <div className="title">Số voucher đã dùng</div>
                  <div className="number">500</div>
                  <div className="rate-block">
                    <div className="text">Tăng 2%</div>
                    <div className="icon-svg"><CaretUpOutlined /></div>
                  </div>
                </div>
              </div>
              <div className="bg-img-total ctrl-img-vouche">
                <img src="/bg-total.svg" alt="" />
              </div>
            </div>
            <div className="chart">
              <ChartFunnel />
            </div>
          </div>

          <div className='title-date'>
            <div className="title-block">
              Bảng thống kê chiến dịch gửi thông báo từ
              <span>2020-11-08</span>
              đến
              <span>2020-12-23</span>
            </div>

            <div className="t-btn-df">
              <div className="icon-svg"><DownloadOutlined /></div>
              <div className="text">Xuất báo cáo</div>
            </div>
          </div>

          <div className="t-table-block table-voucher">
            <Table
              rowClassName={(record, index) => index % 2 === 0 ? 'table-row-dark' : 'table-row-light'}
              columns={columns}
              dataSource={data}
              onChange={onChangeTB}
              pagination={false}
              showSorterTooltip={false}
            />
          </div>
        </div>

      </Layout>
    </div>
  );
}

export default Voucher;
